<template>
  <div class="_make-article ">
    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">ปุ่มประเภทเลือกวัน (Datepicker)</h1>
    </header>
<div class="MarkdownContent hidden-sm-and-down" style="width: 70vw;">
  <v-layout row wrap>
    <v-flex xl3 lg3 md3 style="text-align: center;">
      <div style="text-align: center;">
        <img src="/static/bot component/quickreply/quickreply date.gif" style="width: 170px;" />
      </div>
    </v-flex>
    <v-flex xl9 lg9 md9 style="text-align: left;">
      <br>
      <br>
      <p class="preindent" style="width: 70%; margin-top: 100px;">เป็นรูปแบบปุ่มประเภทเลือกวันและเวลา โดยมีการกำหนดขอบเขตวัน (Min - Max) และจุดเริ่มต้นของวันที่ให้เลือก</p>
    </v-flex>
  </v-layout>
</div>

<div class="MarkdownContent hidden-md-and-up">
      <p class="preindent" style="width: 70vw;">เป็นรูปแบบปุ่มประเภทเลือกวัน โดยมีการกำหนดขอบเขตวัน (Min - Max) และจุดเริ่มต้นของวันที่ให้เลือก</p>
    </div>

<div style="text-align: center;" class="hidden-md-and-up">
      <img src="/static/bot component/quickreply/quickreply date.gif" style="width: 200px;" />
    </div>



 <div class="MarkdownContent hidden-sm-and-down">
      <h3>Request Parameter (JSON)</h3>
      ตัวอย่างกรณี payloadเป็น String
      <br>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="messageSting">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
          <span>Copy to clipboard</span>
        </v-tooltip>
    {
      <span class="colorkey">"label"</span> : <span class="colorvalue">"เลือกวันประชุม"</span>,
      <span class="colorkey">"type"</span> : <span class="colorvalue">"datepicker"</span>,
      <span class="colorkey">"min"</span> : <span class="colorvalue">"2017-01-20"</span>,
      <span class="colorkey">"initial"</span> : <span class="colorvalue">"2018-01-24"</span>,
      <span class="colorkey">"max"</span> : <span class="colorvalue">"2018-01-24"</span>,
      <span class="colorkey">"payload"</span> : <span class="colorvalue">"meeting"</span>
    }
      </code>
      <br>
      <br>
      ตัวอย่างกรณี payloadเป็น Dictionary(json)
      <br>

      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="messageJson">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
          <span>Copy to clipboard</span>
        </v-tooltip>
    {
      <span class="colorkey">"label"</span> : <span class="colorvalue">"เลือกวันประชุม"</span>,
      <span class="colorkey">"type"</span> : <span class="colorvalue">"datepicker"</span>,
      <span class="colorkey">"min"</span> : <span class="colorvalue">"2017-01-20"</span>,
      <span class="colorkey">"initial"</span> : <span class="colorvalue">"2018-01-24"</span>,
      <span class="colorkey">"max"</span> : <span class="colorvalue">"2018-01-24"</span>,
      <span class="colorkey">"payload"</span> : <span class="colorvalue">{ "keyword": "meeting", "subject": "ประชุมบริษัท" }</span>
    }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>label</td>
          <td>String</td>
          <td>คำที่จะปรากฎบนปุ่ม ควรเป็นคำสั้นๆ เข้าใจง่าย</td>
        </tr>
        <tr>
          <td>type</td>
          <td>String</td>
          <td>ประเภทของปุ่ม ในที่นี้เป็น datepicker</td>
        </tr>
        <tr>
          <td>min</td>
          <td>String</td>
          <td>วันที่น้อยที่สุดให้เลือก</td>
        </tr>
        <tr>
          <td>initial</td>
          <td>String</td>
          <td>วันเริ่มต้นให้เลือก</td>
        </tr>
        <tr>
          <td>max</td>
          <td>String</td>
          <td>วันที่มากที่สุดให้เลือก</td>
        </tr>
        <tr>
          <td>payload</td>
          <td>String หรือ Dictionary (json)</td>
          <td>เป็นข้อมูลที่webhook จะได้รับไปพร้อมกับข้อความ เมื่อผู้ใช้กดปุ่ม</td>
        </tr>
      </table>

      <br>

    </div>

    <div class="hidden-md-and-up">
      <h3>Request Parameter (JSON)</h3>
      ตัวอย่างกรณี payloadเป็น String
      <br>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="messageSting">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
          <span>Copy to clipboard</span>
        </v-tooltip>
    {
      <span class="colorkey">"label"</span> : <span class="colorvalue">"เลือกวันประชุม"</span>,
      <span class="colorkey">"type"</span> : <span class="colorvalue">"datepicker"</span>,
      <span class="colorkey">"min"</span> : <span class="colorvalue">"2017-01-20"</span>,
      <span class="colorkey">"initial"</span> : <span class="colorvalue">"2018-01-24"</span>,
      <span class="colorkey">"max"</span> : <span class="colorvalue">"2018-01-24"</span>,
      <span class="colorkey">"payload"</span> : <span class="colorvalue">"meeting"</span>
    }
      </code>
      <br>
      <br>
      ตัวอย่างกรณี payloadเป็น Dictionary(json)
      <br>

      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="messageJson">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
          <span>Copy to clipboard</span>
        </v-tooltip>
    {
      <span class="colorkey">"label"</span> : <span class="colorvalue">"เลือกวันประชุม"</span>,
      <span class="colorkey">"type"</span> : <span class="colorvalue">"datepicker"</span>,
      <span class="colorkey">"min"</span> : <span class="colorvalue">"2017-01-20"</span>,
      <span class="colorkey">"initial"</span> : <span class="colorvalue">"2018-01-24"</span>,
      <span class="colorkey">"max"</span> : <span class="colorvalue">"2018-01-24"</span>,
      <span class="colorkey">"payload"</span> : <span class="colorvalue">{ "keyword": "meeting", "subject": "ประชุมบริษัท" }</span>
    }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>label</td>
          <td>String</td>
          <td>คำที่จะปรากฎบนปุ่ม ควรเป็นคำสั้นๆ เข้าใจง่าย</td>
        </tr>
        <tr>
          <td>type</td>
          <td>String</td>
          <td>ประเภทของปุ่ม ในที่นี้เป็น datepicker</td>
        </tr>
        <tr>
          <td>min</td>
          <td>String</td>
          <td>วันที่น้อยที่สุดให้เลือก</td>
        </tr>
        <tr>
          <td>initial</td>
          <td>String</td>
          <td>วันเริ่มต้นให้เลือก</td>
        </tr>
        <tr>
          <td>max</td>
          <td>String</td>
          <td>วันที่มากที่สุดให้เลือก</td>
        </tr>
        <tr>
          <td>payload</td>
          <td>String หรือ Dictionary (json)</td>
          <td>เป็นข้อมูลที่webhook จะได้รับไปพร้อมกับข้อความ เมื่อผู้ใช้กดปุ่ม</td>
        </tr>
      </table>

      <br>

    </div>



  </div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
    messageSting: '{\n\t"label": "เลือกวันประชุม",\n\t"type": "datepicker",\n\t"min": "2018-01-20",\n\t"initial": "2018-01-24",\n\t"max": "2018-01-24",\n\t"payload": "meeting"\n}',
    messageJson: '{\n\t"label": "เลือกวันประชุม",\n\t"type": "datepicker",\n\t"min": "2018-01-20",\n\t"initial": "2018-01-24",\n\t"max": "2018-01-24",\n\t"payload": { "keyword": "meeting", "subject": "ประชุมบริษัท" }\n}'
  }),
  methods: {
  }
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbfail {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid orange;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: orange;
    color: #FFFFFF;
}
.EndpointVerberror {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid red;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: red;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}


</style>


// WEBPACK FOOTER //
// src/components/home/api/quickreply/quickreply_datepicker.vue